module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_styled_01-cc61fe40c21df8e030a5c7ea6a7c683a.png";